const features = [
  {
    icon: "ri-file-image-line",
    title: "原稿质感",
    desc: "保留线条的起伏与网点细节，画面经得起放大细看，仿佛面对摊开在案上的原稿。",
  },
  {
    icon: "ri-book-2-line",
    title: "实体书翻页",
    desc: "接近捧起一本实体书的翻页感受，章节之间衔接自然，通勤路上也能安静读完一话。",
  },
  {
    icon: "ri-grid-fill",
    title: "印刷网点",
    desc: "还原印刷时代的网点层次与灰度过渡，让复古漫画的笔墨明暗更见功力。",
  },
  {
    icon: "ri-sun-line",
    title: "泛黄纸色",
    desc: "温润的旧纸底色与柔和的明暗对比，久看不累眼，把收藏的旧刊搬进屏幕。",
  },
];

export default function Features() {
  return (
    <section id="features" className="paper-bg">
      <div className="container-paper py-14 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 text-xs tracking-[0.18em] text-primary-600">
            <i className="ri-magic-line text-sm leading-none" aria-hidden="true"></i>
            阅读特色
          </span>
          <h2 className="mt-3 font-display text-3xl text-foreground-950 md:text-4xl">
            把「翻书」的感觉，搬进屏幕
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            纸盒漫画网不是简单换一层滤镜，而是从纸色、网点到翻页节奏，整体还原纸质阅读的质感。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5">
          {features.map((f, idx) => (
            <div
              key={f.title}
              className={`group flex gap-5 rounded-lg border p-6 transition-colors md:p-7 ${
                idx === 0
                  ? "border-primary-300 bg-primary-50"
                  : "border-background-300 bg-background-50 hover:border-primary-200"
              }`}
            >
              <span
                className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-md md:h-16 md:w-16 ${
                  idx === 0
                    ? "bg-primary-500 text-background-50"
                    : "bg-secondary-100 text-secondary-700 group-hover:bg-accent-500 group-hover:text-background-50"
                }`}
              >
                <i className={`${f.icon} text-2xl leading-none`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-display text-xl text-foreground-950">{f.title}</h3>
                <p className="mt-2 text-sm leading-7 text-foreground-600">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}